export const ANSWERS_API_ENDPOINT = 'answers';
export const QUESTIONS_API_ENDPOINT = 'questions';
export const QUIZ_ATTEMPTS_API_ENDPOINT = 'quiz-attempts';


// WEBPACK FOOTER //
// ./src/state/modules/quiz/configurations/endpoints.js